define.alias("shared/components/shared/post/secondary/caption-writer/loader", "settings/components/shared/post/secondary/caption-writer/loader");